// extracted by css-extract-rspack-plugin
export default {"breadcrumb":"y4QFh","link":"RJ44G"};